import moment from "moment"

// headers
export const segParentHeader = [
    'PLM Segment Alarms', '', '', '', '', '', '', '', '', '', '', '', '',
    'Short', '', '', '', '', '',
    'Over', '', '',
    '', '', '', '', '', ''
]
export const stnParentHeader = [
    'PLM Station Alarms', '', '', '', '', '', '', '', '', '', '', '', '',
    'Short', '', '', '', '', '',
    'Over', '', '',
    '', '', '', '', '', ''
]
export const childHeader = [
    'Console', '', 'PLM', '', '', 'Description', '', '', 'Comments', '', '', '', '',
    '5min', '10min', '1hr', '5hr', '24hr', 'Total Short',
    '1hr', '24hr', 'Total Over',
    'Total Alarms',
    'Updated By', '', 'Updated On', '', ''
]
const empySheetData = [['', '', '', '', '', '', '', '', 'No Rows To Show', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '']]

export const getWorkSheetData = (data, ccSelected, weekSelected, sheetFlag) => {
    // worksheet data
    // Caution : Don't remove empty space, these works for borders and cell merging

    const ccLabel = "Control Centre:"
    const ccValue = ccSelected.value + " Control Centre"
    const weekLabel = "Week:"
    const weekValue = "Start: " +
        moment(new Date(weekSelected)).format('MM/DD/yyyy') + " 07:00:00 MT — End: " +
        moment(new Date(weekSelected)).add(7, 'd').format('MM/DD/yyyy') + " 07:00:00 MT"
    const parentHeader = sheetFlag === 'Seg' ? segParentHeader : stnParentHeader

    let worksheetData = [...empySheetData]
    if (data.length) {
        worksheetData = data.map(obj => {
            const console = obj?.Console || ' '
            const tag = obj?.Tag || ' '
            const description = obj?.Description || ' '
            const comments = obj?.Comments || ' '
            const short5M = obj?.Short5M || 0
            const short10M = obj.Short10M || 0
            const short1H = obj.Short1H || 0
            const short5H = obj.Short5H || 0
            const short24H = obj.Short24H || 0
            const shortTotal = obj.ShortTotal || 0
            const over1H = obj.Over1H || 0
            const over24H = obj.Over24H || 0
            const overTotal = obj.OverTotal || 0
            const alarmTotal = obj.AlarmTotal || 0
            const updatedBy = obj?.UpdatedBy || ' '
            const updatedOn = obj?.UpdatedOn ? obj.UpdatedOn.replace(',', ' ') : ' '

            delete obj.Type
            delete obj.ID
            delete obj.ControlCentre
            delete obj.WeekStart

            return [
                console, '', tag, '', '', description, '', '', comments, '', '', '', '', // PLM segement|station alarm fields
                short5M, short10M, short1H, short5H, short24H, shortTotal, // Short fields
                over1H, over24H, overTotal, // Over fields
                alarmTotal, // total alarm
                updatedBy, '', updatedOn, '', ''
            ]
        })
    }

    // set headers in segment sheet
    worksheetData.unshift(childHeader)
    worksheetData.unshift(parentHeader)
    // 2 rows gap
    worksheetData.unshift([''])
    worksheetData.unshift([''])
    // slicers - control centre & week
    worksheetData.unshift([ccLabel, '', ccValue, '', '', ' ', weekLabel, weekValue, '', '', '', '', '', ''])

    return worksheetData
}
